import type { DataTableColumn } from '@/shared/components/data-table';
import type { Sku } from '../types';
import type { SkuRenderContext } from '../hooks/useSkuListTable';

type SkuCol = DataTableColumn<Sku, SkuRenderContext>;

function escapeCSVValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  let str = String(value);
  if (/^[=+\-@\t\r]/.test(str)) str = "'" + str;
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function exportableCols(cols: SkuCol[]): SkuCol[] {
  return cols.filter((c) => !c.noFilter);
}

export function exportToCSV(
  rows: Sku[],
  cols: SkuCol[],
  ctx: SkuRenderContext,
  filename = 'skus',
): void {
  const exportCols = exportableCols(cols);
  const header = exportCols.map((c) => escapeCSVValue(c.label)).join(',');
  const body = rows
    .map((r) => exportCols.map((c) => escapeCSVValue(c.getValue(r, ctx))).join(','))
    .join('\n');
  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function copyToClipboard(rows: Sku[], cols: SkuCol[], ctx: SkuRenderContext): Promise<void> {
  const exportCols = exportableCols(cols);
  const header = exportCols.map((c) => c.label).join('\t');
  const body = rows
    .map((r) => exportCols.map((c) => String(c.getValue(r, ctx) ?? '')).join('\t'))
    .join('\n');
  return navigator.clipboard.writeText(`${header}\n${body}`);
}
